export const getParams = (props) => (
	{
		module: props.currentModule.id,
		team: props.currentTeam && props.currentTeam.id,
	}
)
